var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBodyStructure4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 104,
    viewBox: "0 0 87 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7067 0.895101H65.2657C68.0736 0.887346 70.8555 1.43319 73.452 2.50136C76.0484 3.56953 78.4083 5.13902 80.3966 7.11993C82.3849 9.10084 83.9623 11.4542 85.0387 14.0452C86.115 16.6363 86.6691 19.414 86.6691 22.2193V96.6845C86.6691 98.6035 85.906 100.444 84.5477 101.801C83.1895 103.158 81.3473 103.92 79.4264 103.92H7.60493C5.68407 103.92 3.84188 103.158 2.48362 101.801C1.12537 100.444 0.362305 98.6035 0.362305 96.6845L0.362305 22.2193C0.362305 16.5638 2.61108 11.1399 6.61392 7.14081C10.6168 3.14175 16.0458 0.895101 21.7067 0.895101Z",
    fill: "#FFCC00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBodyStructure4);
export default __webpack_public_path__ + "static/media/body-structure4.5553e3ed9664ec1e4f236828d98c797a.svg";
export { ForwardRef as ReactComponent };